import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { NavigationService } from '../services/navigation.service';

// store
import { AppState } from '../app-reducer';
import { Store } from '@ngrx/store';

// reactive
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable()
export class ErrorPageService implements CanActivate {
  appState$: Observable<any>;

  constructor(
    private navigationService: NavigationService,
    private router: Router,
    private store: Store<AppState>,
  ) {
    this.appState$ = this.store.select('sections');
  }

  canActivate(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const data = route.data as Array<string>;
    const authValue =  route.routeConfig.data['auth'];
    const queryParamsAuthValue = route.queryParams['auth'];
    const currentUrl = this.router.url;
    let completed: boolean = false;
    let expired:boolean=false;

    // check if completed
    this.appState$.pipe(first())
    .subscribe((state) => {
      completed = state.completed,
      expired= state.expired
    });

    // application completed
    if (completed) {
      this.navigationService.nextSectionRelative('error');

      return false;
    }

    //
    if (data['isProgressRoute'] && data['isProgressRoute'] === true){
      if(expired){
       this.router.navigate(['express', 'error-session']);
        return false;
      }
    }

    // if authenticated from these methods, let user proceed
    if (this.isAuthPage(currentUrl) || data['auth'] === true || authValue === true || queryParamsAuthValue === 'true' ) {
      return true;
    } else {
      // if(authValue !== true && data['auth'] !== true ) {
      // // send them to error page where they'll be prompted to login
      //   this.navigationService.nextSectionRelative('error-page');
      //   return false; 
      // }
   
      return true;
    }
  }

  isAuthPage(currentUrl){
    if (currentUrl.includes('financial-professional') || currentUrl.includes('welcome') || currentUrl.includes('find-application')){
      return true;
    }
    return false;
  }
}
